import React from "react"
import {get, set, cloneDeep} from "lodash"
import PropTypes from "prop-types"

import notify from "@irati/utils/notify"
import {injectIntl} from "@irati/utils/lang"

import GetInsWizard from "../../client/query/InsWizard"
import CreatePrivateQuestionGroup from "./question/CreatePrivateQuestionGroup"
import UpdateInsWizard from "../../client/mutation/InsWizard"
import UpdateCycle from "./cycle/Update"
import BatchSaveQuestions from "./question/BatchSave"
import getEditableQuestions from "../../helpers/question/getEditableQuestions"

const _getUpdateInsWizardParams = (uuid, cycle) => {
  const existingGroups = get(cycle, "preferences.groupIds") || []
  const newCycle = cloneDeep(cycle)
  set(newCycle, "preferences.groupIds", [...existingGroups, uuid])
  return {questionGroupId: uuid, cycle: newCycle}
}

const SaveCycleAndQuestions = ({children, onCompleted, formatMessage}) => {
  const handleNotifyError = (error) => {
    if (!error) {
      notify.error({position: "top-right", message: "insights.errors.batchSave"}, formatMessage)
    }
  }
  return (
    <UpdateCycle onCompleted={onCompleted}>
      {(saveCycle, {loading: cycleUpdateLoading}) => {
        return (
          <BatchSaveQuestions onCompleted={saveCycle} onError={handleNotifyError}>
            {(saveQuestions, {loading: saveQuestionsLoading}) => {
              return (
                <UpdateInsWizard onCompleted={() => saveQuestions()}>
                  {(updateInsWizard) => {
                    return (
                      <GetInsWizard>
                        {({cycle, questionGroupId, questions}) => {
                          return (
                            <CreatePrivateQuestionGroup onCompleted={({createQuestionGroup: {uuid}}) => {
                              const params = _getUpdateInsWizardParams(uuid, cycle)
                              updateInsWizard({variables: {params}})
                            }}>
                              {(createQuestionGroup, {loading: createQuestionGroupLoading}) => {
                                const handleSave = () => {
                                  const {tenant} = cycle
                                  const editableQuestions = getEditableQuestions(questions, tenant)
                                  if (editableQuestions.length > 0) {
                                    if (!questionGroupId) {
                                      return createQuestionGroup()
                                    } else {
                                      return saveQuestions()
                                    }
                                  } else {
                                    return saveCycle()
                                  }
                                }
                                const loading = cycleUpdateLoading || createQuestionGroupLoading || saveQuestionsLoading

                                return children(handleSave, {loading})
                              }}
                            </CreatePrivateQuestionGroup>
                          )
                        }}
                      </GetInsWizard>
                    )
                  }}
                </UpdateInsWizard>
              )
            }}
          </BatchSaveQuestions>
        )
      }}
    </UpdateCycle>
  )
}

SaveCycleAndQuestions.propTypes = {
  children: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
  formatMessage: PropTypes.func.isRequired
}

SaveCycleAndQuestions.defaultProps = {
  children: PropTypes.func.isRequired,
  onCompleted: () => null
}


export default injectIntl(SaveCycleAndQuestions)
